export class PageHeader {
  title: string;
  refNumber?: string;
  additionalInfo?: string;
  moreOptionList?: any[];
  additionalButtonList: any[];
}
